import { isAuthenticated } from '../common/permissions';
import { Dashboard } from './Dashboard';

export default [
  {
    exact: true,
    path: '/home',
    permissions: [isAuthenticated],
    component: Dashboard,
  },
];
